const allElementsString = arr => {
  return arr.every(elem => typeof elem === 'string');
};

const allElementsNumbers = arr => {
  return arr.every(elem => typeof elem === 'number');
};

const formatArray = params => {
  if (params.length <= 0) {
    params = [];
  } else if (allElementsString(params) || allElementsNumbers(params)) {
    params = [...params];
  } else {
    // Preserve objects that have no .id (e.g. {deal_name, pipe_code, current_stage}).
    // Mapping undefined produces [null] on serialization, which erases stored values.
    params = params.map(val => (val.id !== undefined ? val.id : val));
  }
  return params;
};

const generatePayloadForObject = item => {
  if (item.action_params.id) {
    item.action_params = [item.action_params.id];
  } else {
    item.action_params = [item.action_params];
  }
  return item.action_params;
};

const normalizeConditionValues = values => {
  if (!values) return [];
  if (Array.isArray(values)) {
    return values[0]?.id ? values.map(v => v.id) : values;
  }
  if (typeof values === 'object') {
    return [values.id];
  }
  return [values];
};

const normalizeConditions = conditions => {
  return (conditions || []).map(cond => ({
    ...cond,
    values: normalizeConditionValues(cond.values),
  }));
};

const generatePayload = data => {
  const actions = JSON.parse(JSON.stringify(data));
  let payload = actions.map(item => {
    if (item.action_name === 'if_else') {
      const p = item.action_params || {};
      item.action_params = {
        ...p,
        conditions: normalizeConditions(p.conditions),
        if_actions: generatePayload(p.if_actions || []),
        else_actions: generatePayload(p.else_actions || []),
      };
      return item;
    }
    if (Array.isArray(item.action_params)) {
      item.action_params = formatArray(item.action_params);
    } else if (typeof item.action_params === 'object') {
      item.action_params = generatePayloadForObject(item);
    } else if (!item.action_params) {
      item.action_params = [];
    } else {
      item.action_params = [item.action_params];
    }
    return item;
  });
  return payload;
};

export default generatePayload;
